<script lang="ts">
	// components/navbar/menu/MenuButton.svelte
	// IMPORTS
	import { onDestroy } from 'svelte';
	import mediaQueries from '$stores/mq';

	// TYPES
	import { getDrawerStore } from '@skeletonlabs/skeleton';
	import type { DrawerSettings } from '@skeletonlabs/skeleton';

	// EXPORTS

	// VARIABLES
	const drawerStore = getDrawerStore();
	let open = false;

	let drawerSettings: DrawerSettings = {
		id: 'nav-menu',
		bgDrawer: 'bg-white text-white ',
		width: 'w-full md:w-[320px]',
		height: 'h-screen',
		position: 'top',
		rounded: 'rounded-none',
	};

	const unsubscribe = mediaQueries.subscribe((media) => {
		// Update the position property based on the viewport size
		drawerSettings.position = media.medium ? 'right' : 'top';
	});

	function handleClick() {
		open = !open;

		if (open) {
			drawerStore.open(drawerSettings);
		} else {
			drawerStore.close();
		}
	}

	onDestroy(() => {
		unsubscribe();
	});
</script>

<button class:active="{open}" on:click="{handleClick}">
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke-width="2"
		stroke-linecap="round"
		stroke-linejoin="round"
		class="menu-burger"
		><line x1="4" x2="20" y1="12" y2="12"></line><line
			x1="4"
			x2="20"
			y1="6"
			y2="6"
		></line><line x1="4" x2="20" y1="18" y2="18"></line></svg
	>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		stroke-width="2"
		stroke-linecap="round"
		stroke-linejoin="round"
		class="menu-x"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg
	>
</button>

<style lang="scss">
	button {
		height: 100%;
		width: 56px;
		display: flex;
		align-items: center;
		justify-content: center;

		svg {
			display: block;
			stroke: var(--brand-secondary);

			&:hover {
				stroke: var(--brand-primary);
			}
		}
	}

	.menu-x {
		display: none;
	}

	.menu-burger {
		display: block;
	}

	.active {
		.menu-x {
			display: block;
		}

		.menu-burger {
			display: none;
		}
	}
</style>
